/* FLGNTLT — Warenkorb-Geschenk mit Uhr (todo #132, CEO 19.10.2026). Deploy: deploy-warenkorb.mjs --paket=WG.
 *
 * Die Haelfte der Besucher mit Ware im Korb (Zufall, einmal je Browser) bekommt den Artprint gratis in
 * den Korb gelegt — solange sie innerhalb der Uhr bestellt. Laeuft die Uhr ab, nimmt der Shop ihn wieder
 * heraus und das Angebot kommt fuer diesen Browser nicht zurueck. Die andere Haelfte ist die
 * Vergleichsgruppe (CEO: „mal ja, mal nein").
 *
 * Grundsaetze, jeder einzeln am echten Warenkorb gemessen (work/geschenk-2026-10-19/04-mechanik-probe.mjs):
 *   - Das Geschenk ist der echte Artprint mit der Eigenschaft _fg=1, gratis ueber den Code aus der
 *     Konfiguration (BxGy, 1 je Bestellung). Der Code steht nur im Korb, solange das Geschenk drin ist.
 *   - 🔴 Das Geschenk darf NIE etwas kosten. Nach jedem Einlegen wird der Korb zurueckgelesen: kostet die
 *     Zeile nicht 0,00, ist der Code verbraucht (Limit), abgelaufen oder abgeschaltet — dann kommt alles
 *     wieder heraus und das Angebot endet still. Damit ist `geschenk-code.mjs --aus` der Notschalter.
 *   - 🔴 Ein eigener Code des Kunden wird nie verdraengt: Shopify schaltet bei nicht kombinierbaren
 *     Codes einen davon stumm (PX916MEB5K8Z gegen den Geschenk-Code). Dann gibt es kein Geschenk.
 *   - Menge 2 teilt Shopify in eine Gratis- und eine 18-€-Zeile ⇒ Geschenk immer genau 1 Stueck.
 *   - Ohne anderes Teil im Korb greift der Rabatt nicht ⇒ Geschenk raus, bis wieder etwas drin liegt.
 *   - Die Uhr ist echt: feste Endzeit je Browser, kein Neustart beim Neuladen (UWG Anhang Nr. 7).
 *   - Dawn ersetzt beim Neuzeichnen ganze Bereiche des Korbs (K201): Kasten und Zeilenmarke werden bei
 *     jedem Lauf frisch gesucht und eingesetzt, nie gemerkt.
 *
 * Pruefstaende (nur Test-Theme oder mit localStorage flgntlt_intern=1): ?fg=A | ?fg=B | ?fg=reset,
 * ?fg_sek=60 verkuerzt die Uhr fuer den Test.
 */
(function () {
  'use strict';

  var konfigEl = document.getElementById('fg-konfig');
  if (!konfigEl) return;
  var K;
  try { K = JSON.parse(konfigEl.textContent); } catch (e) {
    if (window.console && console.error) console.error('[flgntlt-geschenk] Konfiguration nicht lesbar:', e);
    return;
  }

  var SPEICHER = 'fg_' + K.aktion;
  var QUELLE = 'flgntlt-geschenk';
  var MESS_URL = 'https://dtevowjxfviqiyjwrpef.supabase.co/functions/v1/cart-events';
  var START = Date.parse(K.start);
  var ENDE = Date.parse(K.ende);
  var routen = window.routes || {};
  var R_KORB = (routen.cart_url || '/cart') + '.js';
  var R_ADD = (routen.cart_add_url || '/cart/add') + '.js';
  var R_CHANGE = (routen.cart_change_url || '/cart/change') + '.js';
  var R_UPDATE = (routen.cart_update_url || '/cart/update') + '.js';

  // ───────────────────────────────────────────── Zustand je Browser

  function lesen() {
    try { return JSON.parse(window.localStorage.getItem(SPEICHER) || 'null'); } catch (e) { return null; }
  }
  function schreiben(z) {
    try { window.localStorage.setItem(SPEICHER, JSON.stringify(z)); } catch (e) { /* ohne Speicher kein Angebot, siehe zuteilen() */ }
  }
  function intern() {
    try { return window.localStorage.getItem('flgntlt_intern') === '1'; } catch (e) { return false; }
  }
  var sh = window.Shopify || {};
  var testErlaubt = (sh.theme && sh.theme.role !== 'main') || intern();
  var parameter = new URLSearchParams(window.location.search);
  var erzwungen = null;
  var testSekunden = 0;
  if (testErlaubt) {
    // ?fg=A|B lenkt nur eine NEUE Ziehung — eine laufende oder abgelaufene Uhr bleibt, wie sie ist (so sieht
    // der Pruefer, was ein Kunde sieht). ?fg=neu = von vorn mit Gruppe A, ?fg=reset = nur loeschen.
    var p = parameter.get('fg');
    if (p === 'reset' || p === 'neu') { try { window.localStorage.removeItem(SPEICHER); } catch (e) { /* egal */ } }
    if (p === 'A' || p === 'B') erzwungen = p;
    if (p === 'neu') erzwungen = 'A';
    testSekunden = parseInt(parameter.get('fg_sek') || '0', 10) || 0;
  }
  var neuGezogen = parameter.get('fg') === 'neu' && testErlaubt;
  var zustand = lesen();

  function imFenster() { var j = Date.now(); return j >= START && j < ENDE; }

  // ───────────────────────────────────────────── Warenkorb-API

  // Positionen der Geschenkzeilen aus jedem frischen Korb (fuer die Zeilenmarke, siehe zeilenMarkieren).
  var letzteGeschenkPositionen = [];
  function positionenMerken(korb) {
    if (!korb || !korb.items) return korb;
    letzteGeschenkPositionen = [];
    korb.items.forEach(function (i, n) { if (istGeschenk(i)) letzteGeschenkPositionen.push(String(n + 1)); });
    return korb;
  }
  function holenKorb() {
    return fetch(R_KORB, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('cart.js HTTP ' + r.status); return r.json(); })
      .then(positionenMerken);
  }
  function senden(url, body) {
    return fetch(url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok || j.status) throw new Error(url + ' HTTP ' + r.status + ' ' + (j.description || j.message || ''));
        return positionenMerken(j);
      });
    });
  }

  // Dawns pubsub: `subscribe`/`publish` sind globale Funktionen, PUB_SUB_EVENTS aber eine globale
  // `const` (constants.js) — erreichbar ueber den Namen, NICHT als window.PUB_SUB_EVENTS.
  function pubsub() {
    try {
      if (typeof subscribe === 'function' && typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        return { an: subscribe, senden: publish, ereignis: PUB_SUB_EVENTS.cartUpdate };
      }
    } catch (e) { /* ohne Dawn-pubsub bleiben Ausklapp-Beobachter und Takt */ }
    return null;
  }

  function istGeschenk(i) { return !!(i.properties && i.properties._fg === '1'); }
  function geschenkZeilen(korb) { return (korb.items || []).filter(istGeschenk); }
  function andereTeile(korb) {
    return (korb.items || []).filter(function (i) { return !istGeschenk(i); }).reduce(function (s, i) { return s + i.quantity; }, 0);
  }
  function codesOhneUnseren(korb) {
    return (korb.discount_codes || []).map(function (d) { return d.code; })
      .filter(function (c) { return c && c.toUpperCase() !== K.code.toUpperCase(); });
  }
  function token(korb) { return String(korb.token || '').split('?')[0]; }

  // Welche Bereiche nach einer Aenderung neu gezeichnet werden: offener Ausklapp, Warenkorbseite, Zaehler.
  function bereiche() {
    var liste = ['cart-icon-bubble'];
    var seite = document.querySelector('cart-items');
    if (seite && typeof seite.getSectionsToRender === 'function') {
      seite.getSectionsToRender().forEach(function (s) { if (liste.indexOf(s.section) === -1) liste.push(s.section); });
    }
    if (document.querySelector('cart-drawer')) liste.push('cart-drawer');
    return liste;
  }
  function neuZeichnen(antwort) {
    var sec = antwort && antwort.sections;
    if (!sec) return;
    var drawer = document.querySelector('cart-drawer');
    var drawerOffen = drawer && drawer.classList.contains('active');
    // Leert unser Herausnehmen den Korb (das Geschenk war die letzte Zeile), muss Dawns Leer-Zustand
    // mitziehen — Dawn setzt ihn nur in seinem eigenen updateQuantity (K215).
    var leer = antwort.item_count === 0;
    [drawer, document.querySelector('cart-items'), document.getElementById('main-cart-footer')].forEach(function (el) {
      if (el) el.classList.toggle('is-empty', leer);
    });
    try {
      if (drawer && sec['cart-drawer']) {
        if (drawerOffen && typeof drawer.renderContents === 'function') {
          drawer.renderContents(antwort);
        } else if (pubsub()) {
          pubsub().senden(pubsub().ereignis, { source: QUELLE });
        }
      }
      var seite = document.querySelector('cart-items');
      if (seite && typeof seite.getSectionsToRender === 'function') {
        seite.getSectionsToRender().forEach(function (s) {
          var html = sec[s.section];
          var wurzel = document.getElementById(s.id);
          if (!html || !wurzel) return;
          var ziel = wurzel.querySelector(s.selector) || wurzel;
          var quelle = new DOMParser().parseFromString(html, 'text/html').querySelector(s.selector);
          if (quelle) ziel.innerHTML = quelle.innerHTML;
        });
      } else if (sec['cart-icon-bubble']) {
        var blase = document.getElementById('cart-icon-bubble');
        var neu = new DOMParser().parseFromString(sec['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
        if (blase && neu) blase.innerHTML = neu.innerHTML;
      }
    } catch (e) {
      if (window.console && console.error) console.error('[flgntlt-geschenk] Neuzeichnen fehlgeschlagen:', e);
    }
  }

  // ───────────────────────────────────────────── Messung (gleiche Regeln wie flgntlt-herbst.js)

  function analyticsErlaubt() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      return !!(cp && typeof cp.analyticsProcessingAllowed === 'function' && cp.analyticsProcessingAllowed() === true);
    } catch (e) { return false; }
  }
  function melden(ereignis, korb, detail) {
    if (!korb || !analyticsErlaubt()) return;
    var t = token(korb);
    if (!t) return;
    var seite = document.body && document.body.classList.contains('template-cart') ? 'cart'
      : (document.querySelector('cart-drawer.active') ? 'drawer' : 'other');
    var daten = {
      v: 1, event: ereignis, cart_token: t, page: seite,
      item_count: korb.item_count | 0, total_cents: korb.total_price | 0, discount_cents: korb.total_discount | 0,
      currency: korb.currency || '', viewport_w: window.innerWidth | 0, locale: sh.locale || '',
      theme_role: (sh.theme && sh.theme.role) || '', theme_id: String((sh.theme && sh.theme.id) || ''),
      intern: intern(), ua_short: window.innerWidth < 750 ? 'mobil' : 'desktop',
      detail: detail ? String(detail).slice(0, 64) : null
    };
    var body = JSON.stringify(daten);
    try {
      if (navigator.sendBeacon && navigator.sendBeacon(MESS_URL, new Blob([body], { type: 'text/plain' }))) return;
    } catch (e) { /* unten der Fallback */ }
    fetch(MESS_URL, { method: 'POST', body: body, keepalive: true, headers: { 'Content-Type': 'text/plain' } })
      .catch(function (e) { if (window.console && console.error) console.error('[flgntlt-geschenk] Messung nicht gesendet:', e); });
  }

  // ───────────────────────────────────────────── Ablauf

  function korbSichtbar() {
    if (document.body && document.body.classList.contains('template-cart')) return true;
    var d = document.querySelector('cart-drawer');
    return !!(d && d.classList.contains('active'));
  }

  function zuteilen(korb) {
    var g = erzwungen || (Math.random() < K.anteil ? 'A' : 'B');
    var jetzt = Date.now();
    var minuten = testSekunden ? testSekunden / 60 : K.minuten;
    zustand = { g: g, st: g === 'A' ? 'laeuft' : 'aus', seit: jetzt, ende: g === 'A' ? jetzt + minuten * 60000 : null, tok: token(korb), drin: false };
    schreiben(zustand);
    // Ohne lokalen Speicher keine echte Uhr (sie stuende bei jedem Laden neu) ⇒ dann gar kein Angebot.
    if (!lesen()) { zustand = { g: g, st: 'aus' }; return Promise.resolve(korb); }
    melden('geschenk_gruppe', korb, g);
    if (g === 'A') melden('geschenk_start', korb, String(Math.round((zustand.ende - jetzt) / 1000)));
    // Die Gruppe steht in der Bestellung (Attribute mit _ sind in der Kasse unsichtbar).
    return senden(R_UPDATE, { attributes: attribute() }).catch(function (e) {
      if (window.console && console.error) console.error('[flgntlt-geschenk] Gruppe nicht gespeichert:', e);
      return korb;
    });
  }

  // Gruppe UND Endzeit stehen im Korb: sie reisen mit, wenn derselbe Korb auf einem anderen Geraet oder
  // ueber einen Mail-Link geoeffnet wird, und stehen spaeter in der Bestellung (Auswertung: nach Ablauf bestellt?).
  function attribute() {
    return { _fg_gruppe: zustand.g, _fg_ende: zustand.ende ? String(zustand.ende) : '' };
  }

  // Kein lokaler Zustand, aber der Korb kennt schon eine Gruppe (anderes Geraet, geloeschter Speicher,
  // Mail-Link): Gruppe und Uhr aus dem Korb uebernehmen statt neu zu ziehen. Eine abgelaufene Uhr bleibt
  // abgelaufen; eine Endzeit weiter als eine Laufzeit in der Zukunft wird gekappt (Attribute sind veraenderbar).
  function ausKorbUebernehmen(korb) {
    var a = korb.attributes || {};
    if (neuGezogen || (a._fg_gruppe !== 'A' && a._fg_gruppe !== 'B')) return false;
    var jetzt = Date.now();
    var ende = parseInt(a._fg_ende || '0', 10) || null;
    if (ende && ende > jetzt + K.minuten * 60000) ende = jetzt + K.minuten * 60000;
    var st = a._fg_gruppe === 'B' ? 'aus' : (ende && jetzt < ende ? 'laeuft' : 'weg');
    zustand = { g: a._fg_gruppe, st: st, seit: ende ? ende - K.minuten * 60000 : jetzt, ende: ende, tok: token(korb), drin: false, aus: 'korb' };
    schreiben(zustand);
    return true;
  }

  function beenden(st, korb, detail) {
    zustand.st = st;
    zustand.drin = false;
    schreiben(zustand);
    if (st === 'weg') melden('geschenk_ende', korb, detail);
    else if (st === 'abgelehnt') melden('geschenk_abgelehnt', korb, detail);
    else if (st === 'gesperrt') melden('geschenk_gesperrt', korb, detail);
  }

  // Nimmt Geschenkzeilen und unseren Code aus dem Korb; fremde Codes bleiben unberuehrt.
  function herausnehmen(korb) {
    var zeilen = geschenkZeilen(korb);
    var kette = Promise.resolve(korb);
    zeilen.forEach(function (z) {
      kette = kette.then(function () { return senden(R_CHANGE, { id: z.key, quantity: 0 }); });
    });
    return kette.then(function (k) {
      var hatCode = (k.discount_codes || korb.discount_codes || []).some(function (d) { return d.code.toUpperCase() === K.code.toUpperCase(); });
      if (!hatCode && !zeilen.length) return k;
      return senden(R_UPDATE, { discount: codesOhneUnseren(k).join(','), sections: bereiche().join(','), sections_url: window.location.pathname })
        .then(function (a) { neuZeichnen(a); return a; });
    });
  }

  // Legt das Geschenk (genau 1) und den Code in den Korb und prueft danach, ob es wirklich 0,00 kostet.
  function einlegen(korb) {
    var fremde = codesOhneUnseren(korb);
    var vorherGueltig = (korb.discount_codes || []).filter(function (d) { return d.applicable; })
      .map(function (d) { return d.code.toUpperCase(); });
    var zeilen = geschenkZeilen(korb);
    var kette = Promise.resolve(korb);
    if (!zeilen.length) {
      kette = senden(R_ADD, { items: [{ id: K.variante, quantity: 1, properties: { _fg: '1' } }] })
        .catch(function (e) {
          // Ausverkauft oder gesperrt: nicht bei jedem Korb-Ereignis erneut versuchen.
          beenden('gesperrt', korb, 'einlegen');
          throw e;
        });
    } else {
      zeilen.forEach(function (z, i) {
        var soll = i === 0 ? 1 : 0;
        if (z.quantity !== soll) kette = kette.then(function () { return senden(R_CHANGE, { id: z.key, quantity: soll }); });
      });
    }
    return kette
      .then(function () {
        return senden(R_UPDATE, { discount: fremde.concat([K.code]).join(','), sections: bereiche().join(','), sections_url: window.location.pathname });
      })
      .then(function (a) {
        var g = geschenkZeilen(a);
        var unser = (a.discount_codes || []).filter(function (d) { return d.code.toUpperCase() === K.code.toUpperCase(); })[0];
        var fremdStumm = (a.discount_codes || []).some(function (d) {
          var c = d.code.toUpperCase();
          return c !== K.code.toUpperCase() && !d.applicable && vorherGueltig.indexOf(c) !== -1;
        });
        var grund = !unser || !unser.applicable ? 'code' : fremdStumm ? 'konflikt' : (g.length !== 1 || g[0].quantity !== 1 || g[0].final_line_price !== 0) ? 'preis' : '';
        if (!grund) { neuZeichnen(a); return { ok: true, korb: a }; }
        beenden('gesperrt', a, grund);
        return herausnehmen(a).then(function (b) { return { ok: false, korb: b }; });
      });
  }

  var beschaeftigt = false;
  var nochmal = false;
  var attributVersuche = 0;

  function pruefen() {
    if (beschaeftigt) { nochmal = true; return; }
    beschaeftigt = true;
    nochmal = false;
    holenKorb()
      .then(function (korb) { return schritt(korb); })
      .catch(function (e) { if (window.console && console.error) console.error('[flgntlt-geschenk]', e); })
      .then(function () {
        beschaeftigt = false;
        zeichnen();
        if (nochmal) window.setTimeout(pruefen, 250);
      });
  }

  function schritt(korb) {
    var andere = andereTeile(korb);
    var zeilen = geschenkZeilen(korb);

    // Ausserhalb des Fensters, ohne Vorrat oder ohne Angebot fuer diesen Browser: nur aufraeumen.
    if (!imFenster() || !K.verfuegbar) {
      if (zustand && zustand.st === 'laeuft') beenden('weg', korb, !K.verfuegbar ? 'vorrat' : 'fenster');
      return zeilen.length ? herausnehmen(korb) : null;
    }
    if (!zustand && ausKorbUebernehmen(korb)) return schritt(korb);
    if (!zustand) {
      if (!andere || !korbSichtbar()) return null;
      return zuteilen(korb).then(function () { return zustand.st === 'laeuft' ? holenKorb().then(schritt) : null; });
    }
    // Gruppe und Endzeit muessen im Korb stehen. Ein anderes Skript schreibt ebenfalls Korb-Attribute
    // (_omgLp_cartId) und hat unseres in der Abnahme einmal verloren — dann still nachtragen, je Seite
    // hoechstens zweimal (ueberschreibt der Fremde dauernd, darf das keine Schleife werden).
    var a = korb.attributes || {};
    var sollEnde = zustand.ende ? String(zustand.ende) : '';
    if (zustand.g && korb.item_count > 0 && attributVersuche < 2 && (a._fg_gruppe !== zustand.g || (sollEnde && a._fg_ende !== sollEnde))) {
      attributVersuche += 1;
      return senden(R_UPDATE, { attributes: attribute() }).then(schritt);
    }
    if (zustand.st !== 'laeuft') return zeilen.length ? herausnehmen(korb) : null;

    // Neuer Korb (nach einer Bestellung oder Ablauf des Korbs): das Angebot gilt einmal.
    if (zustand.tok && token(korb) && token(korb) !== zustand.tok) {
      beenden('genutzt', korb, 'neuer-korb');
      return zeilen.length ? herausnehmen(korb) : null;
    }
    if (!zustand.tok && token(korb)) { zustand.tok = token(korb); schreiben(zustand); }

    if (Date.now() >= zustand.ende) {
      beenden('weg', korb, 'ablauf');
      return herausnehmen(korb);
    }
    if (!andere) {
      // Ohne gekauftes Teil greift der Rabatt nicht — Geschenk raus, die Uhr laeuft weiter.
      if (zeilen.length) { zustand.drin = false; schreiben(zustand); return herausnehmen(korb); }
      return null;
    }
    if (zustand.drin && !zeilen.length) {
      // Der Kunde hat das Geschenk selbst entfernt: respektieren, Code raus, nie wieder anbieten.
      beenden('abgelehnt', korb, 'entfernt');
      return herausnehmen(korb);
    }
    var hatCode = (korb.discount_codes || []).some(function (d) { return d.code.toUpperCase() === K.code.toUpperCase() && d.applicable; });
    var sauber = zeilen.length === 1 && zeilen[0].quantity === 1 && zeilen[0].final_line_price === 0 && hatCode;
    if (sauber) { if (!zustand.drin) { zustand.drin = true; schreiben(zustand); } return null; }
    return einlegen(korb).then(function (r) {
      if (r.ok) { zustand.drin = true; schreiben(zustand); }
    });
  }

  // ───────────────────────────────────────────── Anzeige

  function text(schluessel, werte) {
    var s = (K.t && K.t[schluessel]) || '';
    Object.keys(werte || {}).forEach(function (k) { s = s.split('{' + k + '}').join(werte[k]); });
    return s.split('{titel}').join(K.titel || '');
  }
  function geld(cents) {
    try {
      var b = cents / 100;
      return new Intl.NumberFormat(K.locale || 'de', { style: 'currency', currency: K.waehrung || 'EUR', minimumFractionDigits: b % 1 ? 2 : 0 }).format(b);
    } catch (e) { return (cents / 100) + ' ' + (K.waehrung || 'EUR'); }
  }
  function uhrzeit(ms) {
    try { return new Intl.DateTimeFormat(K.locale || 'de', { hour: '2-digit', minute: '2-digit' }).format(new Date(ms)); } catch (e) { return ''; }
  }
  function rest() {
    var s = Math.max(0, Math.ceil((zustand.ende - Date.now()) / 1000));
    var m = Math.floor(s / 60);
    return (m < 10 ? '0' : '') + m + ':' + (s % 60 < 10 ? '0' : '') + (s % 60);
  }
  function aktiv() {
    return !!(zustand && zustand.st === 'laeuft' && zustand.drin && imFenster() && Date.now() < zustand.ende);
  }

  function kastenBauen() {
    var box = document.createElement('div');
    box.className = 'fg-kasten';
    box.setAttribute('data-fg-kasten', '');
    box.innerHTML =
      '<img class="fg-kasten__bild" alt="" width="48" height="60">' +
      '<div class="fg-kasten__text">' +
        '<p class="fg-kasten__kicker"><span class="fg-kasten__punkt" aria-hidden="true"></span><span></span></p>' +
        '<p class="fg-kasten__titel"></p>' +
        '<p class="fg-kasten__zeile"></p>' +
      '</div>' +
      '<p class="fg-kasten__uhr" aria-hidden="true"></p>' +
      '<div class="fg-kasten__balken" aria-hidden="true"><span></span></div>' +
      '<p class="fg-kasten__klein"></p>';
    box.querySelector('.fg-kasten__bild').setAttribute('src', K.bild || '');
    box.querySelector('.fg-kasten__kicker span:last-child').textContent = text('kicker');
    box.querySelector('.fg-kasten__titel').textContent = text('titel') + ' · ' + text('wert', { wert: geld(K.wert_cents) });
    box.querySelector('.fg-kasten__zeile').textContent = text('zeile', { zeit: uhrzeit(zustand.ende) });
    box.querySelector('.fg-kasten__klein').textContent = text('klein', { limit: String(K.limit) });
    return box;
  }

  // Kasten im Ausklapp und auf /cart: direkt ueber der Artikelliste, innerhalb von .js-contents (K119).
  function kaestenSetzen(an) {
    var orte = [
      { wurzel: document.querySelector('#CartDrawer-CartItems'), vor: '.drawer__cart-items-wrapper' },
      { wurzel: document.querySelector('#main-cart-items .js-contents'), vor: 'table.cart-items, .cart-items' }
    ];
    orte.forEach(function (o) {
      if (!o.wurzel) return;
      var da = o.wurzel.querySelector('[data-fg-kasten]');
      if (!an) { if (da) da.parentNode.removeChild(da); return; }
      if (!da) {
        var vor = o.wurzel.querySelector(o.vor);
        if (!vor) return;
        da = kastenBauen();
        vor.parentNode.insertBefore(da, vor);
      }
      da.querySelector('.fg-kasten__uhr').textContent = rest();
      var anteil = Math.max(0, Math.min(1, (zustand.ende - Date.now()) / (zustand.ende - zustand.seit)));
      da.querySelector('.fg-kasten__balken span').style.transform = 'scaleX(' + anteil.toFixed(4) + ')';
    });
  }

  // Zeilenmarke: die Geschenkzeile traegt „Geschenk" statt Mengenwahl. Zuordnung ueber die Position im
  // Korb (CartDrawer-Item-N / CartItem-N), weil Geschenk und gekaufter Artprint dieselbe Adresse haben.
  function zeilenMarkieren() {
    document.querySelectorAll('.fg-zeile').forEach(function (tr) {
      if (letzteGeschenkPositionen.indexOf(tr.getAttribute('data-fg-pos')) === -1) {
        tr.classList.remove('fg-zeile');
        var b = tr.querySelector('.fg-zeile__marke');
        if (b) b.parentNode.removeChild(b);
      }
    });
    letzteGeschenkPositionen.forEach(function (pos) {
      ['CartDrawer-Item-' + pos, 'CartItem-' + pos].forEach(function (id) {
        var tr = document.getElementById(id);
        if (!tr) return;
        tr.classList.add('fg-zeile');
        tr.setAttribute('data-fg-pos', pos);
        if (!tr.querySelector('.fg-zeile__marke')) {
          var name = tr.querySelector('.cart-item__name');
          var marke = document.createElement('span');
          marke.className = 'fg-zeile__marke';
          marke.textContent = text('badge');
          if (name && name.parentNode) name.parentNode.insertBefore(marke, name.nextSibling);
        }
      });
    });
  }

  var reiter = null;
  function reiterSetzen(an) {
    var zeigen = an && !korbSichtbar();
    if (!zeigen) { if (reiter) reiter.hidden = true; return; }
    if (!reiter) {
      reiter = document.createElement('button');
      reiter.type = 'button';
      reiter.className = 'fg-reiter';
      reiter.innerHTML =
        '<svg class="fg-reiter__icon" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false">' +
        '<path fill="none" stroke="currentColor" stroke-width="1.6" d="M3 9h18v4H3zM5 13v8h14v-8M12 9v12M12 9c-2-3-6-4-6-1.5S10 9 12 9zm0 0c2-3 6-4 6-1.5S14 9 12 9z"/></svg>' +
        '<span class="fg-reiter__text"></span><span class="fg-reiter__zeit"></span>';
      reiter.addEventListener('click', function () {
        var d = document.querySelector('cart-drawer');
        if (d && typeof d.open === 'function') d.open();
        else window.location.href = routen.cart_url || '/cart';
      });
      document.body.appendChild(reiter);
    }
    reiter.hidden = false;
    reiter.querySelector('.fg-reiter__text').textContent = text('reiter');
    reiter.querySelector('.fg-reiter__zeit').textContent = rest();
    reiter.setAttribute('aria-label', text('reiter_aria', { rest: rest() }));
  }

  var zeichnetGerade = false;
  function zeichnen() {
    if (zeichnetGerade) return;
    zeichnetGerade = true;
    if (beobachter) beobachter.disconnect();
    var an = aktiv();
    try {
      kaestenSetzen(an);
      zeilenMarkieren();
      reiterSetzen(an);
    } finally {
      zeichnetGerade = false;
      if (beobachter) beobachter.observe(document.body, { childList: true, subtree: true });
    }
  }

  // ───────────────────────────────────────────── Ausloeser

  var beobachter = null;
  var takt = null;
  function taktStarten() {
    if (takt) return;
    takt = window.setInterval(function () {
      if (!zustand || zustand.st !== 'laeuft') { window.clearInterval(takt); takt = null; zeichnen(); return; }
      if (Date.now() >= zustand.ende) { pruefen(); return; }
      zeichnen();
    }, 1000);
  }

  var verzoegert = null;
  function anstossen(ms) {
    window.clearTimeout(verzoegert);
    verzoegert = window.setTimeout(function () { pruefen(); taktStarten(); }, ms || 300);
  }

  function start() {
    // Jede Korb-Aenderung des Themes (Kaufknopf, Menge, Entfernen) meldet sich ueber Dawns pubsub.
    var ps = pubsub();
    if (ps) ps.an(ps.ereignis, function (e) { if (!e || e.source !== QUELLE) anstossen(400); });
    else if (window.console && console.error) console.error('[flgntlt-geschenk] Dawn-pubsub fehlt — Korb-Aenderungen nur ueber Ausklapp und Takt');
    var drawer = document.querySelector('cart-drawer');
    if (drawer && window.MutationObserver) {
      new MutationObserver(function () { if (drawer.classList.contains('active')) anstossen(150); })
        .observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }
    // Neu gerenderte Korb-Bereiche bekommen Kasten und Zeilenmarke sofort wieder (K201).
    if (window.MutationObserver) {
      var rahmen = false;
      beobachter = new MutationObserver(function () {
        if (rahmen) return;
        rahmen = true;
        window.requestAnimationFrame(function () { rahmen = false; zeichnen(); });
      });
      beobachter.observe(document.body, { childList: true, subtree: true });
    }
    document.addEventListener('visibilitychange', function () { if (!document.hidden && zustand && zustand.st === 'laeuft') anstossen(100); });
    window.addEventListener('pageshow', function (e) { if (e.persisted && zustand && zustand.st === 'laeuft') anstossen(100); });

    // Erster Lauf: laufende Uhr, offene Warenkorbseite oder ein Pruefstand mit erzwungener Gruppe.
    if ((zustand && zustand.st === 'laeuft') || korbSichtbar() || erzwungen) anstossen(erzwungen ? 600 : 200);
    else if (zustand) zeichnen();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
